import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context; _forEachInstanceProperty(_context = ownKeys(Object(source), true)).call(_context, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context2; _forEachInstanceProperty(_context2 = ownKeys(Object(source))).call(_context2, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import { styled, StyleSheet, text } from '@rexlabs/styling';
import { Form as ReactForm, useReactFormsContext } from '@rexlabs/react-forms';
import { isString } from 'lodash';
var defaultStyles = StyleSheet({
  formError: _objectSpread({}, text.styles({
    target: 'form.errorText',
    fallback: 'normal.default',
    color: 'color.textStyle.body.error'
  }))
});

function Form(_ref) {
  var s = _ref.styles,
      name = _ref.name,
      children = _ref.children,
      FormError = _ref.FormError,
      props = _objectWithoutProperties(_ref, ["styles", "name", "children", "FormError"]);

  var _useReactFormsContext = useReactFormsContext(),
      touched = _useReactFormsContext.touched,
      errors = _useReactFormsContext.errors;

  var formErrorProps = _objectSpread({}, !isString(FormError) ? {
    touched: touched,
    errors: errors
  } : {});

  return /*#__PURE__*/React.createElement(ReactForm, _extends({}, props, {
    name: name,
    id: name,
    "data-form-name": name
  }), FormError && _Object$keys(errors).length > 0 && /*#__PURE__*/React.createElement(FormError, _extends({}, s('formError'), formErrorProps)), children);
}

export default styled(defaultStyles)(Form);